// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__kZKu2","title":"ClientCherryInfo_title__2ZO0z","itemText":"ClientCherryInfo_itemText__tc0Ne"};